<template>
  <div class="HomeVideo">
    <div class="hvLeft" @click="toVideoDetail(msg.sp[0].id)">
      <van-image
        width="40rem"
        height="22.5rem"
        lazy-load
        :src="msg.sp[0].imageurl"
      />
      <img class="bfq bfq2" src="../assets/ic_bofang.png" alt="" />
      <div class="hvLname">
        <!-- 2020最新风景与您共赏 -->
        {{ msg.sp[0].title }}
      </div>
    </div>
    <div class="hvRight" style="flex:1">
      <ul class="hvRlist">
        <li
          class="hvRlistIn"
          v-for="(item, index) in msg.sp.slice(1, 5)"
          :key="index"
          @click="toVideoDetail(item.id)"
        >
          <van-image
            width="260px"
            height="146px"
            lazy-load
            :src="item.imageurl"
          />
          <div class="hvRname">
            {{ item.title }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeVideo",
  props: ["msg"],
  methods: {
    toVideoDetail(id) {
      window.open("https://yooobei.com/#/VideoDetail?id=" + id);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.HomeVideo{
    height 23.75rem
    padding .9375rem 0 0 0
    display flex

}
.hvLeft{
    position relative
    cursor pointer
}
.hvLname{
    width 40rem
    height 2.5rem
    line-height 2.5rem
    text-align center;
    background rgba(0, 0, 0, 0.4)
    position absolute
    left 0
    bottom 1.3125rem
    color #fff
    cursor:pointer
}
.hvLname:hover{
    background  rgba(255, 94, 4, 1)
}

.hvRight{
    margin-left .6875rem
    padding-bottom 1.3125rem

}
.hvRlist{
    height 100%
    display flex
    flex-wrap wrap
    justify-content space-between
    align-content space-between
}
.hvRname{
    font size 1rem;
    font-weight:500;
    text-align center
    line-height:1.75rem;
}
.bfq2{
    bottom  4.375rem
}
.hvRlistIn{
  cursor pointer
  color:rgba(51,51,51,1);
}
.hvRlistIn:hover{
  color rgba(255, 94, 4, 1) !important
}
</style>
